import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

import { ToggleIcon } from "./ToggleIcon";

export function Checkbox(
    props: Omit<ComponentProps<typeof ToggleIcon>, "iconSpec">
) {
    return (
        <ToggleIcon
            className={cn("border-0", props.className)}
            iconSpec={{
                unchecked: {
                    name: "CheckboxUnchecked",
                    enabled: {
                        color: "var(--grey-300)"
                    },
                    hover: {
                        color: "var(--grey-300)"
                    }
                },
                checked: {
                    name: "CheckboxChecked",
                    enabled: {
                        color: "var(--primary-main)"
                    },
                    hover: {
                        color: "var(--primary-main)"
                    }
                }
            }}
            {...props}
        />
    );
}
